import { useQueryWithUserId } from '@northladder/services';

import { COSMETIC_EVALUATION_API } from '../cosmeticEvaluationClient';
import { ICosmeticsAssessmentApiOptions } from '../types';

/**
 * This is to track the devices images list query.
 */
const DEVICE_IMAGES_LIST_KEY = 'devices-images-list-key';

/**
 * This hook fetches a list of device dimensions details and tokens and urls to
 * which images would later be uploaded.
 */
export const useDeviceImagesListQuery = ({
  assessmentType,
  baseURL,
  sessionId,
}: ICosmeticsAssessmentApiOptions) => {
  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    queryKey: [
      DEVICE_IMAGES_LIST_KEY,
      baseURL,
      sessionId,
      assessmentType,
      baseURL,
    ],
    queryFn: () =>
      COSMETIC_EVALUATION_API.fetchDeviceImageUploadsList({
        assessmentType,
        baseURL,
        sessionId,
      }),
    retry: false,
    enabled: !!sessionId && !!assessmentType && !!baseURL,
    refetchOnWindowFocus: false,
  });

  return {
    error,
    isError,
    data,
    isPending,
    fetchDevicesImagesList: refetch,
  };
};
